export const PARAMETER_TYPE_ACCESSOR: { [key: string]: string } = {
  LONG: 'asLong',
  MONEY: 'asMoney',
  MONEY2: 'asMoney',
  PERCENT: 'asPercent',
  PERCENT2: 'asPercent',
  RANGE: 'asRange',
  RANGE2: 'asRange',
  RANGE_PERCENT: 'asRange',
  RANGE_PERCENT2: 'asRange',
  STRING_LIST: 'asStringList',
  CURRENCY_CONVERT: 'asStringList',
  STRING_LIST_SENIORITY: 'asStringList',
  KEY_VALUE: 'asKeyValue',
  KEY_VALUE_PERCENT: 'asKeyValue',
  BOOLEAN: 'asBoolean',
};

export function accessorForType(type: string): string {
  return PARAMETER_TYPE_ACCESSOR[type] || 'asString';
}

export function buildParameterSnippet(name: string, type: string): string {
  const accessor = accessorForType(type);
  const variableName = name || 'parametro';
  return `const ${variableName} = context.getParameter('${name}').${accessor}();`;
}
